import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=5d514a60&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=ts&"
export * from "./Tips.vue?vue&type=script&lang=ts&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=5d514a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d514a60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsThumbnail: require('/var/www/packages/theme/components/atoms/Thumbnail.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
